<template>
  <div class="beneficios-save">
    <div class="row">
      <div class="col-xs-12">
        <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
          <font-awesome-icon :icon="'arrow-left'"/>
          Voltar
        </button>
        <h2 class="page-header">
          {{ item.codigo ? 'Editar benefício' : 'Inserir novo benefício' }}
        </h2>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div :class="['form-group', { 'has-error': errors.has('nome') }]">
          <label
            :class="[
              'control-label',
              'custom-font',
              { 'is-danger': errors.has('nome') }
            ]"
            >Nome</label
          >
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon
                :icon="'id-card'"
                :class="[{ 'is-danger': errors.has('nome') }]"
              ></font-awesome-icon>
            </span>
            <input
              ref="nome"
              v-model="item.nome"
              name="nome"
              placeholder="Nome"
              class="form-control"
              v-validate="'required'"
              maxlength="50"
              type="text"
            />
            <div
              :class="[
                'input-group-addon custom-input-group-addon-count',
                { 'is-danger': errors.has('nome') }
              ]"
              v-text="50 - (item.nome ? item.nome.length : 0)"
            ></div>
          </div>
          <small v-if="errors.has('nome')" class="help-block"
            ><font-awesome-icon :icon="'exclamation-triangle'" /> Preenchimento
            obrigatório!</small
          >
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div :class="['form-group', { 'has-error': errors.has('sigla') }]">
          <label
            :class="[
              'control-label',
              'custom-font',
              { 'is-danger': errors.has('sigla') }
            ]"
            >Sigla</label
          >
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon
                :icon="'tags'"
                :class="[{ 'is-danger': errors.has('sigla') }]"
              ></font-awesome-icon>
            </span>
            <input
              ref="sigla"
              v-model="item.sigla"
              name="sigla"
              placeholder="Sigla"
              class="form-control"
              v-validate="'required'"
              maxlength="15"
              type="text"
            />
            <div
              :class="[
                'input-group-addon custom-input-group-addon-count',
                { 'is-danger': errors.has('sigla') }
              ]"
              v-text="15 - (item.sigla ? item.sigla.length : 0)"
            ></div>
          </div>
          <small v-if="errors.has('sigla')" class="help-block"
            ><font-awesome-icon :icon="'exclamation-triangle'" /> Preenchimento
            obrigatório!</small
          >
        </div>
      </div>
      <div class="col-xs-12">
        <div :class="['form-group', { 'has-error': errors.has('descricao') }]">
          <label
            :class="[
              'control-label',
              'custom-font',
              { 'is-danger': errors.has('descricao') }
            ]"
            >Descrição</label
          >
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon
                :icon="'edit'"
                :class="[{ 'is-danger': errors.has('descricao') }]"
              ></font-awesome-icon>
            </span>
            <textarea
              ref="descricao"
              rows="3"
              name="descricao"
              v-model="item.descricao"
              placeholder="Informe a descrição do benefício..."
              class="form-control"
              maxlength="2000"
              v-validate="'required'"
            ></textarea>
            <div
              :class="[
                'input-group-addon custom-input-group-addon-count',
                { 'is-danger': errors.has('descricao') }
              ]"
              v-text="2000 - (item.descricao ? item.descricao.length : 0)"
            ></div>
          </div>
          <small v-if="errors.has('descricao')" class="help-block"
            ><font-awesome-icon :icon="'exclamation-triangle'" /> Preenchimento
            obrigatório!</small
          >
        </div>
      </div>
      <div class="form-group col-xs-12 margem-topo">
        <button
          @click="salvar()"
          class="btn btn-default"
          :disabled="carregando"
        >
          <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
          <font-awesome-icon v-else :icon="'save'" />
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-input-group-addon-count {
  color: #00615c;
}

.fa-tags {
  color: #00615c;
}

.fa-id-card {
  color: #00615c;
}

.fa-edit {
  color: #00615c;
}

.custom-font.is-danger {
  color: #990000;
}

.custom-input-group-addon-count.is-danger {
  color: #990000;
}

.fa-tags.is-danger {
  color: #990000;
}

.fa-id-card.is-danger {
  color: #990000;
}

.fa-edit.is-danger {
  color: #990000;
}

.btn-voltar {
  margin-top: 20px;
}
</style>

<script>
import { request } from '@/request'

export default {
  data() {
    return {
      item: {},
      carregando: false
    }
  },
  created() {
    this.item = { ...this.$route.params.item }
  },
  methods: {
    salvar() {
      this.carregando = !this.carregando
      var me = this
      this.$validator.validateAll().then(result => {
        if (!result) {
          me.$refs[me.$validator.errors.items[0].field].focus()
          me.$toastr.e(me.$validator.errors.items[0].msg)
          me.carregando = !me.carregando
          return
        }

        request
          .post('/assistencia/beneficios/salvar', me.item)
          .then(response => {
            me.$toastr.s(response.data.msg)
            me.$router.push('/admin/assistencia/beneficios')
          })
          .catch(error => {
            if (error.response.status === 401) {
              return
            }

            me.$toastr.e(
              'Houve um erro ao tentar salvar o benefício. Atualize a página e tente novamente.'
            )
          })
          .then(() => {
            me.carregando = !me.carregando
          })
      })
    }
  }
}
</script>

<style scoped>
textarea {
  min-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/assistencia/beneficios/Save.vue